import { render } from "./ProjectChat.vue?vue&type=template&id=7302ccd0&scoped=true"
import script from "./ProjectChat.vue?vue&type=script&lang=js"
export * from "./ProjectChat.vue?vue&type=script&lang=js"

import "./ProjectChat.vue?vue&type=style&index=0&id=7302ccd0&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7302ccd0"]])

export default __exports__